import type { AgentDescriptor } from './types';

const KNOWN_AGENT_LABELS: Record<string, string> = {
  cursor: 'Cursor',
  'github-copilot': 'GitHub Copilot',
  claude: 'Claude',
};

function titleCaseFromId(id: string): string {
  return id
    .split('-')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function normalizeAgentDescriptors(raw: unknown): AgentDescriptor[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  const out: AgentDescriptor[] = [];
  for (const item of raw) {
    if (typeof item === 'string') {
      const id = item.trim();
      if (!id) continue;
      out.push({ id, label: KNOWN_AGENT_LABELS[id] ?? titleCaseFromId(id) });
      continue;
    }
    if (item && typeof item === 'object') {
      const o = item as Record<string, unknown>;
      const idVal = o.id ?? o.value;
      if (typeof idVal !== 'string' || !idVal.trim()) continue;
      const id = idVal.trim();
      const labelRaw = o.label ?? o.name ?? o.title;
      const label =
        typeof labelRaw === 'string' && labelRaw.trim()
          ? labelRaw.trim()
          : KNOWN_AGENT_LABELS[id] ?? titleCaseFromId(id);
      out.push({ id, label, disabled: Boolean(o.disabled) });
    }
  }
  return out;
}
